// * GET =====================================
export const POST_GET = (postId: string) => `/post/${postId}`;

export const POST_GET_SENTIMENT_MANUAL_SCORE = (postId: string) =>
  `/post/${postId}/sentiment_manual_score`;

// * PATCH ===================================
export const POST_PATCH_USER_CATEGORIES = '/post/user_categories';
export const POST_PATCH_WORKFLOW_STAGE = (postId: string) =>
  `/post/${postId}/workflow_stage`;

export const POST_PATCH_PROCESS = `/post/process`;

export const POST_PATCH_PROCESS_SELECTED = `/post/process_selected`;

export const POST_PATCH_MANUAL_SENTIMENT = (postId: string) =>
  `/post/${postId}/manual_sentiment`;

// * POST ====================================
export const POST_POST_USER_CATEGORIES = `/post/user_categories`;

export const POST_POST_ADD_RELATED_POSTS = (postId: string) =>
  `/post/${postId}/add_related_posts`;

export const POST_POST_CREATE_TRANSLATION = (postId: string) =>
  `/post/${postId}/create_translation`;

export const POST_POST_TRANSLATE = (postId: string) =>
  `/post/${postId}/translate`;

export const POST_POST_CREATE_QUICK_STORY_REPORT = (postId: string) =>
  `/post/${postId}/create_quick_story_report`;

export const POST_POST_UPDATE_QUICK_STORY_REPORT = (postId: string) =>
  `/post/${postId}/update_quick_story_report`;

export const POST_POST_GENERATE_SYNOPSIS = (postId: string) =>
  `/post/${postId}/generate_synopsis`;

export const POST_POST_CREATE_SYNOPSIS = (postId: string) =>
  `/post/${postId}/create_synopsis`;

export const POST_POST_UPDATE_SYNOPSIS = (postId: string) =>
  `/post/${postId}/update_synopsis`;

export const POST_POST_DELETE_SYNOPSIS = (postId: string) =>
  `/post/${postId}/delete_synopsis`;

export const POST_POST_IMPORT_BY_URL = `/post/import_by_url`;

export const POST_POST_STORY_POSTS = (postId: string) =>
  `/post/${postId}/story_posts`;

export const POST_POST_STORY_PARAMS = (postId: string) =>
  `/post/${postId}/story_params`;

export const POST_POST_REMOVE_STORY_MEMBERS = (storyPostId: string) =>
  `/post/${storyPostId}/remove_story_members`;

// * DELETE ==================================

// * PUT =====================================

/** Starts the comment collection of one post at once, Global Admin and above (SEN-6208, WAP-2089). */
export const POST_POST_COMMENTS_COLLECT = (postId: string) =>
  `/post/${postId}/comments_collect`;
